<!-- Legacy layout (any caller that does not pass notifyActions) — unchanged -->
<div *ngIf="!notifyActions" class="d-flex flex-nowrap mb-2">
  <div ngbDropdown
       container="body"
       class="dropdown d-none d-sm-inline-block d-lg-none"
       placement="left"
       [ngbTooltip]="!isMobile ? 'More' : ''">
    <button ngbDropdownToggle
            class="waitlist btn btn-info btn-icon mr-2"
            type="button"
            aria-haspopup="true"
            aria-expanded="false"
    >
      <span class="bi bi-three-dots"></span>
    </button>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
      <a ngbDropdownItem
         class="dropdown-item flex"
         (click)="callbacks.addEditParty(party)">
        <tr-icon [icon]="icon.edit" classes="pr-2"></tr-icon>Edit
      </a>

      <frontend-paid-feature
        [user]="user"
        [visibility]="paidService.billingsVisibility === BillingVisibility.STARTER_PLAN_OUTSIDE_US ? BillingVisibility.FULL : undefined"
      >
        <span [ngbTooltip]="chatTooltip(party?.phone)" container="body">
          <a ngbDropdownItem
             [class.disabled]="!party?.phone"
             class="dropdown-item flex align-items-center"
             (click)="callbacks.chatParty(party, index)">
            <tr-icon [icon]="icon.chat" [disabled]="!party?.phone" classes="pr-2"></tr-icon>Chat
          </a>
        </span>
      </frontend-paid-feature>
    </div>
  </div>

  <frontend-paid-feature
    [user]="user"
    [visibility]="paidService.billingsVisibility === BillingVisibility.STARTER_PLAN_OUTSIDE_US ? BillingVisibility.FULL : undefined"
  >
    <button
      (mousedown)="chatBtnFocus[index] = true"
      (mouseup)="chatBtnFocus[index] = false"
      [ngbTooltip]="chatTooltip(party?.phone)"
      container="body"
      class="btn btn-icon btn-info-outline d-inline-block d-sm-none d-lg-inline-block mr-2"
      id="chat-party-{{index}}"
      (click)="callbacks.chatParty(party, index)"
      [disabled]="!party?.phone"
    >
      <tr-icon [icon]="icon.chat" [color]="chatBtnFocus[index] ? color.white : color.blue"></tr-icon>
    </button>
  </frontend-paid-feature>

  <button class="waitlist btn btn-icon btn-info mr-2 d-inline-block d-sm-none d-lg-inline-block" placement="top" container="body" [ngbTooltip]="!isMobile ? 'Edit' : ''" id="edit-party-{{index}}"
          (click)="callbacks.addEditParty(party)">
    <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
  </button>
  <button class="waitlist btn btn-icon btn-danger mr-2" (click)="callbacks.confirmDelete(party)" angularticsCategory="waitlist" angulartics2On="click" angularticsAction="canceled waiting party" id="cancel-party-{{index}}">
    <tr-icon [icon]="icon.cancel" placement="top" [white]="true" [ngbTooltip]="!isMobile ? 'Cancel' : ''" container="body"></tr-icon>
  </button>
  <button (click)="callbacks.checkPartyResources(party)" class="waitlist btn btn-icon btn-success" [disabled]="togoMode ? false : !party?.checkin_time" angularticsCategory="waitlist" angulartics2On="click"
          angularticsAction="served waiting party" id="serve-party-{{index}}">
    <tr-icon [icon]="icon.check" [white]="true" container="body" [ngbTooltip]="!isMobile ? 'Served' : ''" placement="top" classes="tr-bullet"></tr-icon>
  </button>
</div>

<!-- Collapsed layout (waitlist/togo): Text + ⋮ overflow + Serve/Check-in, left-anchored
     at the cell's start like every other column. The buttons stack in columns row to row
     because the Text placeholder below holds that slot on rows that don't show it. -->
<div *ngIf="notifyActions" class="actions4 d-flex flex-nowrap align-items-center mb-2">
  <button
    *ngIf="showTextButton"
    class="btn btn-info-outline btn-icon mr-2 d-flex align-items-center justify-content-center"
    [ngbTooltip]="!isMobile ? 'Text' : ''" container="body" placement="top"
    (click)="notifyActions.smsPage(party)"
    [disabled]="readyNotificationDisabled"
    id="text-party-{{index}}"
    angularticsCategory="waitlist" angulartics2On="click" angularticsAction="sent ready sms"
  >
    <tr-icon [icon]="icon.send" [color]="color.blue"></tr-icon>
  </button>

  <!-- Reserve the Text button's slot when it isn't shown (party not checked in, or no phone)
       so the Cancel and CTA stay column-aligned with rows that do show it. Only when some row
       actually shows the Text button — otherwise the header would line up with an empty
       placeholder instead of the first visible button. Kept at every width: the group is
       left-anchored, so the slot is what lines ⋮ and the CTA up row to row (and card to
       card in the list layout). Inert, space-only. -->
  <span *ngIf="!showTextButton && anyPartyNotifiable"
        class="btn btn-info-outline btn-icon mr-2 d-flex align-items-center justify-content-center invisible"
        aria-hidden="true">
    <tr-icon [icon]="icon.send" [color]="color.blue"></tr-icon>
  </span>

  <div *ngIf="showOverflowMenu" ngbDropdown container="body" class="dropdown mr-2" placement="bottom-right bottom-left top-right top-left">
    <button ngbDropdownToggle class="btn btn-info-outline btn-icon" type="button" aria-haspopup="true" aria-expanded="false"
            [ngbTooltip]="!isMobile ? 'More' : ''" container="body" placement="top">
      <span class="bi bi-three-dots-vertical"></span>
    </button>
    <div ngbDropdownMenu class="dropdown-menu">
      <a ngbDropdownItem class="dropdown-item flex align-items-center"
         *ngIf="canNotifyReady && voicePageNotificationEnabled && !togoMode && notifyActions.voicePage"
         [class.disabled]="readyNotificationDisabled"
         [attr.aria-disabled]="readyNotificationDisabled"
         (click)="voicePage()">
        <tr-icon [icon]="icon.call" classes="pr-2"></tr-icon>Voice notify
      </a>
      <a ngbDropdownItem class="dropdown-item flex align-items-center"
         *ngIf="showChatInMenuItem"
         [class.disabled]="!party?.phone"
         (click)="callbacks.chatParty(party, index)">
        <tr-icon [icon]="icon.chat" classes="pr-2"></tr-icon>Chat
      </a>
      <a ngbDropdownItem class="dropdown-item flex align-items-center"
         (click)="callbacks.confirmDelete(party)">
        <tr-icon [icon]="icon.cancel" classes="pr-2"></tr-icon>Cancel
      </a>
    </div>
  </div>

  <!-- when the menu would hold only Cancel, skip the dropdown and show Cancel directly -->
  <button *ngIf="!showOverflowMenu"
    class="btn btn-icon btn-danger mr-2"
    [ngbTooltip]="!isMobile ? 'Cancel' : ''" container="body" placement="top"
    (click)="callbacks.confirmDelete(party)"
    id="cancel-party-{{index}}"
    angularticsCategory="waitlist" angulartics2On="click" angularticsAction="canceled waiting party">
    <tr-icon [icon]="icon.cancel" [white]="true"></tr-icon>
  </button>

  <!-- boundary between the secondary/destructive buttons and the primary CTA, so Cancel
       is hard to mis-tap next to Serve/Check In on touch. Exactly one CTA always renders. -->
  <span class="action-sep" aria-hidden="true"></span>

  <button *ngIf="!togoMode && !party?.checkin_time"
    class="btn btn-success text-nowrap cta-btn"
    (click)="callbacks.checkIn?.(party)"
    id="checkin-party-{{index}}"
    angularticsCategory="waitlist" angulartics2On="click" angularticsAction="checked in reservation">
    Check In
  </button>
  <button *ngIf="togoMode || party?.checkin_time"
    class="btn btn-info text-nowrap"
    [class.cta-btn]="!togoMode"
    (click)="callbacks.checkPartyResources(party)"
    id="serve-party-{{index}}"
    angularticsCategory="waitlist" angulartics2On="click" angularticsAction="served waiting party">
    Serve
  </button>
</div>
